import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {ProgramApiModel} from '../../../../api/program';

import EmptyClientsSVG from '../../../../assets/icons/empty-state/program-clients.svg';
import EmptyGroupsUnpublishedSVG from '../../../../assets/icons/empty-state/program-groups-unpublished.svg';
import EmptyGroupsSVG from '../../../../assets/icons/empty-state/program-groups.svg';
import {NoResultsView} from '../../../../components/NoResultsView';

type Props = {
  isIndividual: boolean;
  isMainCoach: boolean;
  programStatus: ProgramApiModel['status'];
};

export const CoachCoursesNoResultsView: FC<Props> = ({
  isIndividual,
  isMainCoach,
  programStatus,
}) => {
  const {t} = useI18n();
  const isDraftForMainCoach = isMainCoach && programStatus === 'draft';

  const getEmptyListMessage = () => {
    if (isDraftForMainCoach) {
      return isIndividual
        ? t('shared:once_your_client_joins_group_will_be_created')
        : t('shared:you_can_choose_start_date_in_next_step');
    }

    return isIndividual
      ? t('shared:no_enrolled_clients')
      : t('shared:no_groups_yet');
  };

  const getEmptyListIcon = () => {
    if (isIndividual) {
      return EmptyClientsSVG;
    }

    if (isDraftForMainCoach) {
      return EmptyGroupsUnpublishedSVG;
    }

    return EmptyGroupsSVG;
  };

  return (
    <NoResultsView
      icon={getEmptyListIcon()}
      iconColor={'icon4'}
      iconSize={160}
      text={getEmptyListMessage()}
    />
  );
};
